// Modules
import React from "react";
// @ts-ignore
import { LocalizationContext } from 'react-localize';

// Styles
import './SearchResults.sass';
import './ResultSingleItem.sass';
import { TermConditionRecord } from "Interfaces/Termcondition";
import ReservationService from "Services/reservation.service";
// Components
import MvIcon from "Generic/MvIcon";
import ResortResult from "Interfaces/ResortResultInterface";
import ToolTip from "Generic/ToolTip";
import { EXEC_MODE } from "cfg";
import { ReactAppMode } from "Interfaces/ReactAppModes";
import { logAnalyticData, trackAnalyticData } from "Utils/analytics";
import ConstructionMessage from "./ConstructionMessage";

export interface Props {
  result: ResortResult;
  filtered : boolean;
  onRemoveItem:(propertyCode: string) => void;
  showAvailability:(waitListToggleChecked: boolean)=>void;
  openModal: () => void;
  pointsSearch ?: string;
  isAlternateSearchAvailable:boolean;
  forminputt: {  // Type for forminputt
    numNights: number;  // Include numNights property here
    startDate:string;
    resorts:string[]
  };
  onConstructionMsg: () => void;
  constructionMsgdata:null | string
}
type ResultSingleItemState = {
  termsConditions: TermConditionRecord[];
  numNights:number;
  propertycode:string[];
  beginingdate:string;
  code: string[]; 
  showState: { [code: string]: boolean };
  constructionMessageComponent: JSX.Element | null;
  constructionMessages: React.ReactNode[];
};

class ResultSingleItem extends React.Component<Props,ResultSingleItemState, {}> {
  reservationService: ReservationService;
  state: ResultSingleItemState = {
    termsConditions: [], // Initialize as an empty array
    numNights: this.props.forminputt.numNights, // Default value for numNights (can be adjusted as needed)
    propertycode: [], // Default value for propertycode (empty array of strings)
    beginingdate: this.props.forminputt.startDate,
    code: [],
    constructionMessageComponent:null,
    showState: {},
    constructionMessages: []
  };
  constructor(props:Props) {
    super(props);
    this.removeItem = this.removeItem.bind(this);
    this.showAvailability = this.showAvailability.bind(this);
    this.propCodeModal = this.propCodeModal.bind(this)
    this.abbreviateToUSA = this.abbreviateToUSA.bind(this);
    this.constructionMsg = this.constructionMsg.bind(this);
    this.isDateWithinWindow = this.isDateWithinWindow.bind(this);
    this.reservationService = new ReservationService();
  }

  componentDidMount() {
    const { localize } = this.context;
    console.log('Component Mounted');
    this.reservationService.gettermsCondition()
      .then((termsConditions) => {
        console.log('constructionMsg triggered from componentDidMount', termsConditions);
        this.setState({ termsConditions }, () => {
          // Call constructionMsg after state is updated
          console.log('constructionMsg triggered from componentDidMount');
          this.constructionMsg();
        });
      })
      .catch((error) => {
        console.error('Error fetching terms conditions:', error);
      });
  }

  componentDidUpdate(prevProps: Props, prevState: ResultSingleItemState): void {
    if (this.props.constructionMsgdata !== prevProps.constructionMsgdata) {
      console.log('Construction message has changed:', this.props.constructionMsgdata);
      console.log('constructionMsg triggered from componentDidUpdate');
      this.constructionMsg()
    }
  }
  

  isDateWithinWindow(date: Date, startDate: Date, endDate: Date): boolean {
    return date >= startDate && date <= endDate;
  }

  normalizeCode(code: string | undefined): string {
    return String(code || "").toLowerCase();
  }

  constructionMsg() {
    console.log('Entering constructionMsg method');
    const beginingdate = new Date(this.props.forminputt.startDate);
    const endingDate = new Date(this.props.forminputt.startDate);
    endingDate.setDate(beginingdate.getDate() + this.state.numNights);
  
    const resortCodes = this.props.forminputt.resorts.map((resort) => this.normalizeCode(resort));
    const resultCode = this.normalizeCode(this.props.result.propertyCode);

    let constructionMessages: JSX.Element[] = [];
    let updatedShowState: { [code: string]: boolean } = {};
    let updatedCodes: string[] = [];

    console.log('constructMsg Resort Codes:', resortCodes, resultCode, this.state.termsConditions, beginingdate, endingDate);
  
    // ✅ Ensure termsConditions exists and is an array
    if (!Array.isArray(this.state.termsConditions) || this.state.termsConditions.length === 0) {
      console.warn("termsConditions is empty or not an array.");
      this.setState({
        constructionMessages: [],
        code: [],
        showState: {}
      });
      return; // Exit early if no terms conditions
    }
  
    // ✅ Iterate only if termsConditions is valid
    this.state.termsConditions.forEach((termsCondition) => {
      console.log('Processing termsCondition:', termsCondition);
      if (termsCondition && termsCondition.universalPropertyCode) {
        const universalPropertyCode = termsCondition.universalPropertyCode;
  
        // ✅ Ensure universalPropertyCode is an array before iterating
        if (Array.isArray(universalPropertyCode)) {
          universalPropertyCode.forEach((code: string) => {
            const codeNormalized = this.normalizeCode(code);
            console.log(`Checking code: ${codeNormalized}`);
            if (resortCodes.includes(codeNormalized)) {
              const startDateNotif = termsCondition.arrivalStartDate
                ? new Date(termsCondition.arrivalStartDate)
                : new Date();
              const endDateNotif = termsCondition.arrivalEndDate
                ? new Date(termsCondition.arrivalEndDate)
                : new Date();
  
              let currentDate = new Date(beginingdate);
              let show = false;
  
              // ✅ Check each date in the range
              while (currentDate <= endingDate) {
                if (this.isDateWithinWindow(currentDate, startDateNotif, endDateNotif)) {
                  console.log(`Date ${currentDate.toISOString()} is within window for code ${codeNormalized}. Setting show to true.`);
                  show = true;
                  break;
                }
                currentDate.setDate(currentDate.getDate() + 1);
              }
  
              updatedShowState[codeNormalized] = updatedShowState[codeNormalized] || show;
              if (!updatedCodes.includes(codeNormalized)) {
                updatedCodes.push(codeNormalized);
              }
  
              // ✅ Add only valid components
              constructionMessages.push(
                <ConstructionMessage
                  key={codeNormalized}
                  code={codeNormalized}
                  propscode={resultCode}
                  description={termsCondition.description || ""}
                  show={show}
                />
              );
            } else {
              console.log(`Code ${codeNormalized} not in resortCodes.`);
            }
          });
        } else {
          console.error("universalPropertyCode is not an array:", universalPropertyCode);
        }
      }
    });
  
    this.setState(
      {
        constructionMessages,
        code: updatedCodes,
        showState: updatedShowState,
      },
      () => {
        console.log("Construction messages state updated:", this.state.constructionMessages);
        console.log("Show state updated:", this.state.showState);
        console.log("Code updated:", this.state.code);
      }
    );
  }

// Abbreviate country to "USA" if it's "United States"
  abbreviateToUSA(str:string){
    if (str === 'United States') return 'USA'
      return str
      }
  removeItem() {
    this.props.onRemoveItem(this.props.result.propertyCode);
  }
  showAvailability(waitListToggleChecked: boolean){
    this.props.showAvailability(waitListToggleChecked);
  }
  propCodeModal(boolean:boolean, propCode:string) {
    this.props.openModal();
  }

  handleShowAvailability = () => {
    /** 
     * PWAS analytics on Check Availability
     */
  console.log(this.props.isAlternateSearchAvailable,"show availablility")
    logAnalyticData({ event: 'Select Availability', siteSection: 'Points Reservation', pageName:'Book My Holiday', website:'' }, {
      step:'Step 3:Select Availability',
      errorMessagfe:"",
      notificationType: "",
      errorMessage:"",
      resortID:this.props.result.propertyCode,
      typeofSearch:"",
      customerID:"",
      filtersApplied: "" ,// TODO: Populate the data
      alternativeSearchResorts:this.props.isAlternateSearchAvailable?"yes":"no",
  })
    trackAnalyticData('points:step3');
  }

  render() {
    const { localize } = this.context;
    let content;
    const country = this.abbreviateToUSA(this.props.result.country);
    const resultCode = this.normalizeCode(this.props.result.propertyCode);

    let showPointsAvailable:boolean = true;

    if ([ReactAppMode.VOA, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
      showPointsAvailable = process.env.REACT_APP_POINTS_SEARCH === 'TRUE';
      showPointsAvailable = String(process.env.REACT_APP_POINTS_SEARCH) === String('TRUE');
    }
    else {
      // VCAP
      showPointsAvailable = String(this.props.pointsSearch) === String('TRUE');
    }

    // const showPointsAvailable: boolean = String(process.env.REACT_APP_POINTS_SEARCH || 'TRUE') === 'TRUE';

    const isPulseResort = this.props.result.name && this.props.result.name.toLowerCase().indexOf('pulse') !== -1;

    if (!this.props.result.available[0]) {
      content = (
        <React.Fragment>
          <div className="unavailable-content">
            <div className="unavailable-hotel-info-wrapper">
                <button id={this.props.result.propertyCode.toLowerCase()} onClick={(e)=>this.propCodeModal(true, this.props.result.propertyCode)} className="rn-btn">{this.props.result.name}</button>
                <p id={`ua_${this.props.result.propertyCode.toLowerCase()}`} className="unavailable-date">
                    {this.props.result.resortLocation}
             
                </p>
            </div>
              <div className="unavailable-room-types-wrapper text-align-right">
                <p className="unavailable">{localize("static.content.unavailable")}</p>
              </div>
          </div>
        </React.Fragment>
      );
      // if (!this.props.result.unavailable[0]) {
      //   //Available and unavailable not present in the response
        
      // }
      // else {
      //   //Available is not present but unavailable is present in reposnse
      //   let activity = this.props.result.activities.map(activity => {
      //     let url = `common/cms/mvc/vcap/img/activityIcons/${activity.iconURL}.png`;
      //     return (
      //       <div key={url} className="icon">
      //         <img className="activity-icon" src={url} alt=""/>
      //         <p className="activity-icon-text">{activity.iconURL}</p>
      //       </div>
      //     );
      //   });
      //   content = (
      //     <React.Fragment>
      //       <div className="hotel-info-wrapper">
      //         <div className="resort-image btn-wrapper">
      //           <button data-id={this.props.result.propertyCode.toLowerCase()} onClick={(e)=>this.propCodeModal(true, this.props.result.propertyCode)} className="img-btn">
      //             <img className="resort-result-image" src={this.props.result.resortImage} alt=""/>
      //           </button>
      //         </div>
      //         <div className="eight columns resort-name">
      //           <button data-id={this.props.result.propertyCode.toLowerCase()} onClick={(e)=>this.propCodeModal(true, this.props.result.propertyCode)} className="rn-btn">{this.props.result.name}</button>
      //           <p className="address-line">
      //             {this.props.result.city}, {(this.props.result.state && this.props.result.state != "NO-STATE") ? `${this.props.result.state},`  : "" }{" "}
      //             {country}
      //           </p>
      //           {activity}
      //         </div>
      //       </div>
      //       <div className="room-types-wrapper">
      //         <div className="points room-types-section">
      //           <div className="six columns points">
      //             <p style={{fontWeight:"bold" ,paddingLeft:"4px"}}>{localize("static.content.waitlist-room-types")} </p>

      //             {(this.props.result.unavailable || []).map((room, i) => {
      //               return (
      //                 <span className="rm-type" key={i}>
      //                  <span>{room.display}</span>
      //                   { i < this.props.result.unavailable.length - 1 && ' | '}
      //                 </span>
      //               );
      //             })}
      //           </div>
      //           <div className="six columns text-align-right">
      //             <p className="unavailable">{localize("static.content.unavailable")}</p>
      //             <div className="waitlist-button">
      //               <button className="form-action-button mv-button secondary" type="button">
      //                 {localize("static.content.waitlist")}
      //               </button>
      //             </div>
      //           </div>
      //         </div>
      //       </div>
      //     </React.Fragment>
      // );
      // }
    } else if (this.props.filtered) {
      // Not available based on filter
      content = (
        <React.Fragment>
          <div className="twelve columns">
            <div className='unavail-container'>
              <div className="six columns">
                <button id={this.props.result.propertyCode.toLowerCase()} onClick={(e)=>this.propCodeModal(true, this.props.result.propertyCode)} className="rn-btn">{this.props.result.name}</button>
                <p id={`uaf_${this.props.result.propertyCode.toLowerCase()}`}  className="unavailable-date-filter">
                    {this.props.result.resortLocation}
              
                </p>
              </div>
            </div>
            <div className="unavail-wrapper">
              <p className="unavailable">{localize("static.content.unavailable-based-on-filters")}</p>
            </div>
          </div>
        </React.Fragment>
      );
    } else {
      // Available and Unavailable presenet in response
      let activity = this.props.result.activities.map(activity => {
        let url = activity.iconURL;
        return (
          <div key={url} className="icon">
            <img className="activity-icon" src={url} alt=""/>
            <p className="activity-icon-text">{activity.name}</p>
          </div>
        );
      });
      content = (
        <React.Fragment>
          <div className="hotel-info-wrapper">
            <div className="resort-image btn-wrapper">
              <button data-id={this.props.result.propertyCode.toLowerCase()} onClick={(e)=>this.propCodeModal(true, this.props.result.propertyCode)} className="img-btn">
                <img className={`resort-result-image ${isPulseResort ? 'is-pulse-resort' : ''}`} src={this.props.result.resortImage} alt=""/>
              </button>

            </div>
            <div className="eight columns resort-name">
              <button data-id={this.props.result.propertyCode.toLowerCase()} onClick={(e)=>this.propCodeModal(true, this.props.result.propertyCode)} className="rn-btn">{this.props.result.name}</button>
              <p className="address-line">
                {this.props.result.city}, {(this.props.result.state && this.props.result.state != "NO-STATE") ? `${this.props.result.state},`  : "" }{" "}
                {country}
              </p>
              {activity}
            </div>
          </div>
          <div className="room-types-wrapper">
            <div className="room-types-section">
              <div className="nine columns points">
              <p style={{fontWeight:"bold", paddingLeft:"4px", color: "#5F5F5F",fontFamily:"Arial" }}>{showPointsAvailable ? localize('static.content.points-starting') : localize("static.content.villas-available")}: </p>
                  <div>
                    {
                      showPointsAvailable ? 
                      this.props.result.available.map((room, i) => {
                        return (
                          <div className="rm-type" key={i}>
                            <span>{room.display}</span>
                            : <span>{room.pointsAmount}</span>
                            { i < this.props.result.available.length - 1 && ' | '}
                          </div>
                        );
                      })
                      :
                      this.props.result.available.map((room, i) => {
                        return (
                          <><div className="rm-type" key={i}>
                            <span>{room.display}</span>
                            {/* : <span>{room.pointsAmount}</span> */}
                            {/* { i < this.props.result.available.length - 1 && ' <br/> '} */}
                          </div>{ i < this.props.result.available.length - 1 && <br/>}</>
                        );
                      })
                    }
                    {/*this.props.result.available.map((room, i) => {
                      return (
                        <><div className="rm-type" key={i}>
                          <span>{room.display}</span>
                          {/* : <span>{room.pointsAmount}</span> */}
                          {/* { i < this.props.result.available.length - 1 && ' <br/> '} }
                        </div>{ i < this.props.result.available.length - 1 && <br/>}</>
                      );
                    })*/}
                  </div>
                </div>
                <div className="columns text-align-right check-availability-button">
                  <button  className="form-action-button mv-button primary" type="button"
                    onClick={() => { this.props.showAvailability(false); this.handleShowAvailability(); }}>{localize("static.content.check-availability")}
                  </button>
                </div>
              </div>
            {/* {
              this.props.result.unavailable && this.props.result.unavailable.length > 0 && 
                <div className="points top-dashed-border room-types-section">
                  <div className="nine columns points">
                    <p style={{fontWeight:"bold", paddingLeft:"4px", color: "#5F5F5F",fontFamily:"Arial" }}>Waitlist Room Type(s): </p>

                    {(this.props.result.unavailable || []).map((room, i) => {
                      return (
                        <span className="rm-type" key={i}>
                          <span>{room.display}</span>
                          { i < this.props.result.unavailable.length - 1 && ' | '}
                        </span>
                      );
                    })}
                  </div>
                  <div className="columns text-align-right">
                    <div className="waitlist-button">
                      <button className="form-action-button mv-button secondary"
                        onClick={() => this.props.showAvailability(true)}>
                        Waitlist
                      </button>
                    </div>
                  </div>
                </div>
            } */}
          </div>
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <li data-single-results="true" className={`${this.state.showState[resultCode] && this.state.code.includes(resultCode) ? "borderless" : ""}`}>
          <span className="remove-resort" onClick={this.removeItem}>
            <MvIcon color="rgb(2,150,136)" height="13px" width="13px" icon="x" />
          </span>
          <div className="content">
            {content}
          </div>
        </li>
        {
          Array.isArray(this.state.code) &&
          this.state.code.includes(resultCode) &&
          this.state.showState[resultCode] && ( 
            <li data-single-results="true" className="pading-top">
              {
                this.state.constructionMessages
                  .filter(message => {
                    if (React.isValidElement(message)) {
                      return String(message.props.code).toLowerCase() === resultCode;
                    }
                    return false;
                  })
                  .map(message => message) 
              }
            </li>
          )
        }
      </React.Fragment>
    );
  }
}

ResultSingleItem.contextType = LocalizationContext;

export default ResultSingleItem;
